import {
  normalizeSituacaoComprovanteSindicato,
  pickComprovantesListDates,
  pickSituacaoComprovanteNome,
  resolveAcaoHabilitadaAnalista,
} from "../Sindicato/comprovantesSindicatoUtils";

const normalize = (txt: unknown) =>
  (txt || "").toString().toLowerCase().trim();

export type PaymentListRow = {
  id: number;
  cnpj: string | null;
  sigla: string | null;
  nome: string | null;
  situacao: string;
  envio: string | null;
  /** Data da solicitação de correção (coluna da tabela). */
  solicitacaoCorrecao: string | null;
  correcao: string | null;
  envioFormulario: string | null;
  /** Label "1ª Solicitação" etc. */
  solicitacaoLabel: string | null;
  extratoId: number | null;
  solicitacaoId: number | null;
  idSindicato: number | null;
  bloqueado: boolean;
  /** Analista: false quando status = Comprovantes pendentes. */
  acaoHabilitada: boolean;
  ano: number;
  rowKey: string;
};

/** Lista (legacy ou solicitacoes) → linhas da visão Analista/Admin. */
export const mapComprovantesSolicitacoesToPaymentRows = (
  items: unknown[],
  ano: number,
): PaymentListRow[] => {
  if (!Array.isArray(items)) return [];

  return items.map((raw, index) => {
    const item = (raw ?? {}) as Record<string, unknown>;
    const extratoId =
      (item.extratoId as number | undefined) ??
      (item.solicitacaoId as number | undefined) ??
      (item.idSolicitacaoAvaliacao as number | undefined) ??
      null;
    const idSindicato =
      (item.sindicatoId as number | undefined) ??
      (item.idSindicato as number | undefined) ??
      null;
    const situacaoNome = pickSituacaoComprovanteNome(item);
    const situacaoRaw = situacaoNome || "-";
    // Analista mantém nomes de conferência (não normaliza para "enviados")
    const situacao =
      normalize(situacaoRaw) === "inapto"
        ? "Inapto"
        : situacaoRaw;
    const datas = pickComprovantesListDates(item);

    return {
      id: idSindicato ?? extratoId ?? index + 1,
      cnpj: (item.cnpj as string | undefined) ?? null,
      sigla: (item.sigla as string | undefined) ?? null,
      nome: (item.nome as string | undefined) ?? null,
      situacao,
      envio: datas.envio,
      solicitacaoCorrecao: datas.solicitacaoCorrecao,
      correcao: datas.correcao,
      envioFormulario: datas.envioFormulario,
      solicitacaoLabel: (item.solicitacao as string | undefined) ?? null,
      extratoId,
      solicitacaoId: extratoId,
      idSindicato,
      bloqueado: item.bloqueado === true,
      acaoHabilitada: resolveAcaoHabilitadaAnalista(
        normalizeSituacaoComprovanteSindicato(situacao),
      ),
      ano,
      rowKey: `comp-analista-${extratoId ?? idSindicato ?? index}-${ano}`,
    };
  });
};

export const isInaptoRow = (situacao: unknown) =>
  normalize(situacao) === "inapto";
